import React from 'react'

import cx from 'classnames'

import styles from './styles.module.css'

interface Props {
  className?: string
}

const TypingLoadingDots: React.FC<Props> = ({ className }): JSX.Element => {
  const dots = [0, 1, 2].map((n, index) => (
    <div
      key={index}
      className={cx(styles.Dot, className)}
      style={{ animationDelay: `${n * 0.2}s` }}
    />
  ))

  return <div className={styles.Dots}>{dots}</div>
}

export default TypingLoadingDots
